/**
 * Converts a string to kebab case (e.g., "Hello World!" → "hello-world").
 * Kebab case is all lower-case, non-alphanumeric characters are replaced with a single dash.
 *
 * @param input - The input string to convert.
 * @returns The kebab-cased version of the string.
 */
export default function convertStringKebabCase(input: string): string {
  return input
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-') // replace non-alphanumeric with dashes
    .replace(/^-+|-+$/g, ''); // remove leading/trailing dashes
}
